// react-query query keys defined Here

export const queryKeys = {
  onboard: 'onboard',
  forgotPassword:'forgotPassword',
  verifyUser: 'verifyUser',
  loginUser: 'loginUser',
  getCoachesList: 'getCoachesList',
  getTeachersList: 'getTeachersList',
  verifyCredentials:'verifyCredentials',
  deleteCoach: 'deleteCoach',
  modifyCoachRecord: 'modifyCoachRecord',
  modifySchoolRecord: 'modifySchoolRecord',
  manageCredentials: ' manageCredentials',

  switchRole: 'switchRole',
  cancelAMeeting:'cancelAMeeting',
  getSchoolsList: 'getSchoolsList',
  addSchools: 'addSchools',
  getAllUsers: 'getAllUsers',
  changeTempPassword:'changeTempPassword',
  checkInUser:'checkInUser',
  checkOutUser:'checkOutUser',
  getSentInvites:'getSentInvites',

  userCheckInStatus:'userCheckInStatus',
  getAllNotifications:'getAllNotifications',
  timeSlots:'timeSlots',
  modifyTimeSlots:'modifyTimeSlots',
  inviteNotifications:'inviteNotifications',
  userInvites:'userInvites',
  modifyMeetingInviteStatus:'modifyMeetingInviteStatus',
  readAllNotifications:'readAllNotifications',
  getUserInvites:'getUserInvites',
  getUpcomingMeetingsList:'getUpcomingMeetingsList',
  getMeetingCredentials:'getMeetingCredentials',
  saveMeetingTranscript: 'saveMeetingTranscript',
  saveAIPermission: 'saveAIPermission',
  firstSessionLog:'firstSessionLog',
  surveyStatus:'surveyStatus',
  totalUsers:'totalUsers',
  getSiteLeaderRequests:'getSiteLeaderRequests',
  updateSideLeaderRequest:'updateSideLeaderRequest',
  pairWithEdifier:'pairWithEdifier',
  getPairedEdifiers:'getPairedEdifiers',
  setUserAvailability:'setUserAvailability',
  resetPassword:'resetPassword',
  updateGoals:'updateGoals',
  sendBulkMessages:'sendBulkMessages',
  downloadAppReport:'downloadAppReport',
  getPairedUsersAdmin:'getPairedUsersAdmin',
  endUsersTraining:'endUsersTraining',
  endUsersPairing:'endUsersPairing',
  createPair:'createPair',
  getTodayQuote:'getTodayQuote',
  getAllQuotes:'getAllQuotes',
  addQuote:'addQuote',
  updateQuote:'updateQuote',
  deleteQuote:'deleteQuote',
  bulkUploadQuotes:'bulkUploadQuotes',
  getSchoolStats:'getSchoolStats',
  setSchoolAvailability:'setSchoolAvailability',
  
  // Twilio Video related query keys
  twilioVideoToken: 'twilioVideoToken',
  twilioVideoRoom: 'twilioVideoRoom',
  twilioVideoHealth: 'twilioVideoHealth',
  endTwilioVideoRoom: 'endTwilioVideoRoom',
  
  // Profile related query keys
  getUserProfile: 'getUserProfile',
  
  // Principal related query keys
  getPrincipalsList: 'getPrincipalsList',
  deletePrincipal: 'deletePrincipal',
  updatePrincipal: 'updatePrincipal',
  
  // Goals related query keys
  getGoalsList: 'getGoalsList',
  
  // Survey Results related query keys
  getSurveyResults: 'getSurveyResults',
  
  // Help Articles
  getHelpArticles: 'getHelpArticles',
  getHelpArticle: 'getHelpArticle',
  getHelpCategories: 'getHelpCategories',
  getPopularHelpArticles: 'getPopularHelpArticles',
  
  // Two-Factor Authentication
  enable2FA: 'enable2FA',
  disable2FA: 'disable2FA',
  sendOTP: 'sendOTP',
  verifyOTP: 'verifyOTP',
  resendOTP: 'resendOTP',
  check2FAStatus: 'check2FAStatus',
  
  // Meetings list (admin/site-leader)
  getAllMeetingsList: 'getAllMeetingsList',

  // Audit Logs
  AUDIT_LOGS: 'auditLogs',
  MY_AUDIT_LOGS: 'myAuditLogs',
  USER_AUDIT_LOGS: 'userAuditLogs',
  AUDIT_LOG_STATS: 'auditLogStats',
  FAILED_LOGIN_ATTEMPTS: 'failedLoginAttempts',
};

// Export as QUERY_KEYS for consistency with new code
export const QUERY_KEYS = queryKeys;
